import { Dispatch, SetStateAction, useEffect } from "react";
import classNames from "classnames";
import { Button } from "components/atoms/Button";
import { DropDown } from "components/atoms/DropDown";
import { SearchableDropdown, Typography } from "components/atoms";
import { decodeToken } from "utils/functions/decodeToken";
import { ACT_TEST_TYPE, GMAT_TEST_TYPE, GRE_TEST_TYPE, MCAT_TEST_TYPE, SAT_TEST_TYPE } from "utils/constants";
import "./index.scss";

interface IProps {
  setDropDownSelection?: Dispatch<
    SetStateAction<null | string | { [key: number]: string }>
  >;
  dropdownSelection?: null | string | { [key: number]: string };
  theme?: "light" | "dark";
  selectedCategory: null | string | { [key: number]: string };
  setSelectedCategory: Dispatch<
    SetStateAction<null | string | { [key: number]: string }>
  >;
  selectedSubjectAndTopic: undefined | { group: string; label: string };
  setSelectedSubjectAndTopic: Dispatch<
    SetStateAction<undefined | { group: string; label: string }>
  >;
  setSelectedTopic: any;
  selectedTopic: undefined | { group: string; label: string };
  data?: any;
  onClickSearch: ({
    page,
    selectedCategory,
    selectedSubjectAndTopic,
    selectedTopic,
    selectedSession,
  }: {
    page: number;
    selectedCategory?: any;
    selectedSubjectAndTopic?: any;
    selectedTopic?: any;
    selectedSession?: any;
  }) => void;
  isFetchingData?: boolean;
  setIsSearchBtnClicked: Dispatch<SetStateAction<boolean>>;
  setPage: Dispatch<SetStateAction<number>>;
}

export const LiveOnlineFilterButtonSection = ({
  setDropDownSelection,
  dropdownSelection,
  selectedCategory,
  setSelectedCategory,
  selectedSubjectAndTopic,
  setSelectedSubjectAndTopic,
  setSelectedTopic,
  selectedTopic,
  theme,
  data,
  onClickSearch,
  isFetchingData,
  setIsSearchBtnClicked,
  setPage,
}: IProps) => {
  const payload = decodeToken();

  const testType = payload ? payload.testtype : null;

  const transformedOptions =
    data && Object.keys(data).length > 0 && data.SubjectTopics
      ? [
          { group: "Show all", label: "Show all" },
          ...Object.keys(data.SubjectTopics).flatMap((group: any) =>
            data.SubjectTopics[group].map((item: any) => ({
              group,
              label: item,
            }))
          ),
        ]
      : [];

  const handleSelect = (
    selectedOption: undefined | { group: string; label: string },
    child?: any
  ) => {
    setSelectedSubjectAndTopic(selectedOption);
    setSelectedTopic(child);
  };

  useEffect(() => {
    if (
      selectedCategory &&
      Object.values(selectedCategory)[0] === "Med School Admissions"
    ) {
      setSelectedSubjectAndTopic(undefined);
      setSelectedTopic(undefined);
    }
  }, [selectedCategory]);

  return (
    <div
      className={classNames(
        "live-online-filter-wrapper",
        payload?.testtype === GMAT_TEST_TYPE
          ? "live-online-filter-wrapper-gmat-style"
          : "live-online-filter-wrapper-default-style"
      )}
    >
      <div className={classNames("live-online-filter-btn-section")}>
        {payload?.testtype === MCAT_TEST_TYPE ? (
          <div className="dropdown-item-wrapper">
            <Typography label="Category" variant="h7Med" />
            <DropDown
              data={[
                "Required Topic Focus",
                "Optional Topic Focus",
                "Med School Admissions",
              ]}
              setDropDownSelection={setSelectedCategory}
              defaultSelected={selectedCategory}
            />
          </div>
        ) : null}
        {payload?.testtype === MCAT_TEST_TYPE ? (
          <div
            className={classNames({
              "dropdown-item-wrapper": true,
              "is-disabled":
                selectedCategory &&
                Object.values(selectedCategory)[0] === "Med School Admissions",
            })}
          >
            <Typography
              label="Subjects and Topics"
              variant="h7Med"
              styles="subject-and-topic-text-style"
            />
            <SearchableDropdown
              options={transformedOptions}
              onSelect={handleSelect}
              isDisabled={Boolean(
                selectedCategory &&
                  Object.values(selectedCategory)[0] === "Med School Admissions"
              )}
              styles="subject-and-topic-dropdown-style"
            />
          </div>
        ) : null}
        <div className={classNames("drop-down-section")}>
          <DropDown
            data={[
              "Recent and Upcoming Sessions",
              "Past Sessions",
              "All Sessions",
            ]}
            setDropDownSelection={setDropDownSelection}
            defaultSelected={dropdownSelection}
          />
        </div>
        {payload?.testtype !== GMAT_TEST_TYPE ? (
          <Button
            label="Search"
            type="score"
            icon={false}
            styles="search-btn"
            onClick={() => {
              setIsSearchBtnClicked(true);
              setPage(1);
              switch (testType) {
                case SAT_TEST_TYPE:
                case ACT_TEST_TYPE:
                case GRE_TEST_TYPE:
                  onClickSearch({
                    page: 1,
                    selectedSubjectAndTopic: selectedSubjectAndTopic,
                    selectedTopic: selectedTopic,
                    selectedSession: dropdownSelection,
                  });
                  break;

                default:
                  onClickSearch({
                    page: 1,
                    selectedCategory: selectedCategory,
                    selectedSubjectAndTopic: selectedSubjectAndTopic,
                    selectedTopic: selectedTopic,
                    selectedSession: dropdownSelection,
                  });
                  break;
              }
            }}
            isLoading={isFetchingData}
          />
        ) : null}
      </div>
    </div>
  );
};
